import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import classNames from 'lib/util/classNames'
import styles from './Spacer.module.scss'

/**
 * The `Spacer`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Spacer (props) {
  const { size } = props
  const classNameOutput = useMemo(
    () =>
      classNames([styles.spacer, styles[`size-${normalizeSizeString(size)}`]]),
    [size]
  )

  return <div className={classNameOutput} />
}

/** @type {object} */
Spacer.propTypes = {
  size: PropTypes.string
}

/** @type {object} */
Spacer.defaultProps = {
  size: 'standard'
}

// Memoize
export default memo(Spacer)
